# This is dead code, leaving the empty class for dependent files
# TODO: kill all the algo wallet code
class AlgoWallet

module.exports = AlgoWallet
